// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder_container__3gS0v","load":"placeholder_load__Lcha-"};